
interface OrderNextStepsProps {
  total: number;
}

export const OrderNextSteps = ({ total }: OrderNextStepsProps) => {
  return (
    <div className="bg-white rounded-lg border border-gray-100 p-4 sm:p-6 space-y-3 sm:space-y-4">
      <h2 className="text-xl font-semibold text-gray-800">Prochaines étapes</h2>
      <ol className="space-y-3 sm:space-y-4 text-gray-600">
        <li className="flex items-start gap-2 sm:gap-3">
          <span className="flex-shrink-0 w-6 h-6 sm:w-7 sm:h-7 flex items-center justify-center rounded-full bg-green-100 text-green-600 font-medium text-sm">1</span>
          <div className="space-y-1">
            <p className="font-medium text-sm sm:text-base">Effectuez le virement</p>
            <p className="text-xs sm:text-sm text-gray-500">Envoyez exactement {total.toFixed(2)} $ à Steeve Harris</p>
          </div>
        </li>
        <li className="flex items-start gap-2 sm:gap-3">
          <span className="flex-shrink-0 w-6 h-6 sm:w-7 sm:h-7 flex items-center justify-center rounded-full bg-green-100 text-green-600 font-medium text-sm">2</span>
          <div className="space-y-1">
            <p className="font-medium text-sm sm:text-base">Confirmation du paiement</p>
            <p className="text-xs sm:text-sm text-gray-500">Nous vous contacterons dès réception du paiement</p>
          </div>
        </li>
        <li className="flex items-start gap-2 sm:gap-3">
          <span className="flex-shrink-0 w-6 h-6 sm:w-7 sm:h-7 flex items-center justify-center rounded-full bg-green-100 text-green-600 font-medium text-sm">3</span>
          <div className="space-y-1">
            <p className="font-medium text-sm sm:text-base">Expédition</p>
            <p className="text-xs sm:text-sm text-gray-500">Votre commande sera préparée et expédiée</p>
          </div>
        </li>
      </ol>
    </div>
  );
};
